import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBVp0uVsvlch0WpceCcrnqMu1ytyQTeUeY",
    authDomain: "cookhouse-feedback.firebaseapp.com",
    projectId: "cookhouse-feedback",
    storageBucket: "cookhouse-feedback.firebasestorage.app",
    messagingSenderId: "470556942739",
    appId: "1:470556942739:web:b89ca6093a4fec4a9cc866",
    measurementId: "G-RQ7QLE7RSN"
};

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const auth = getAuth(app);

export { firestore, auth };